module.exports = __webpack_public_path__ + "static/media/55_000085.acd80afe.jpg";